import * as React from 'react';
import styled from 'styled-components';

import SmsIcon from '@material-ui/icons/Sms';
import AssignmentIcon from '@material-ui/icons/Assignment';
import PersonIcon from '@material-ui/icons/Person';
import EventIcon from '@material-ui/icons/Event';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import InsertChartIcon from '@material-ui/icons/InsertChart';
import VideocamIcon from '@material-ui/icons/Videocam';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';
import { ReportTableType } from '../../../api/reports';
import { DATETIME_FORMAT } from '../../../constants';
import Table from '../../../organisms/Table';
import { formatDateTime } from '../../../utils/formatDate';
import {
  inspectorColumns,
  inspectorColumnsOrder,
} from '../../../utils/allActivitiesPageColumns';
import {
  getPermitInspectionById,
  InspectionsType,
  getPermitInspections,
  sendInspectionMessage,
  updatePermitInspection,
} from '../../../api/inspections';
import { getProjects } from '../../../api/projects';
import { getPermits } from '../../../api/permits';
import { getInspectionTypes } from '../../../api/inspectionTypes';
import { getUsers } from '../../../api/users';
import { USER_TYPES_VALUES } from '../../../constants/forms';
import { getVocabulariesDataList } from '../../../api/vocabulary';
import { getCurrentUser } from '../../../api/userSettings';
import useTablePage from '../../../hooks/useTablePage';
import ModalInfo from '../../../molecules/ModalInfo';
import { ModalDefaultDraggable } from '../../../molecules';
import useDevice from '../../../hooks/useDevice';
import PermitInspectionsForm from '../../../forms/permitInspectionForm/PermitInspectionsForm';
import useManuallyUpdate from '../../../hooks/useManuallyUpdate';
import DailyInspections from '../../Responsive/DailyInspections/DailyInspections';
import Wrapper from '../print-mixin';
import logo from '../../../resources/logo.png';
import DailyInspectionRecords from '../DailyInspectionReport/DailyInspectionRecords';
import DailyInspectionsSearchBox from '../DailyInspectionReport/DailyInspectionSearchBox';
import { calculatePeriod } from '../DailyInspectionReport/Utils';
import { RootState } from '../../../redux/root';
import { setInspectorName, setInspectionsTypeData } from '../../../redux/slices/inspectionsSlice';

const StyledRefreshIcon = styled(SmsIcon)`
  fill: #ff8c00;
`;

const DailyInspectorReport = React.forwardRef(
  (
    {
      fromDate,
      toDate,
      inspector,
      setIsValidForExport,
      manuallyUpdate,
      updateTable,
      inspectionStatus,
      toolbar,
    }: ReportTableType & { toolbar?: React.ReactNode },
    ref,
  ) => {
    const [lastComment, setLastComment] = React.useState(
      null,
    );
    const {
      errors,
      control,
      handleSubmit,
      } = useForm<ReportTableType>({
      mode: 'onChange',
    });
    const data = {
      fromDate,
      toDate,
      inspector,
    };
    const [currentUser, setCurrentUser] = React.useState(
      null,
    );
    const [loggedInUserName, setLoggedInUserName] = React.useState('');
    const dispatch = useDispatch();

    const [tableData, setTableData] = useState<InspectionsType[]>([]);
    React.useEffect(() => {
      Promise.all([getCurrentUser(undefined)]).then(
        ([currentUserResponse]) => {
          setCurrentUser(currentUserResponse.data.id);
          const firstName = currentUserResponse.data.firstName || '';
          const lastName = currentUserResponse.data.lastName || '';
          const fullName = `${firstName} ${lastName}`.trim();
          setLoggedInUserName(fullName);
          // Set inspector name in Redux immediately
          if (fullName) {
            dispatch(setInspectorName(fullName));
          }
        },
      );
    }, [dispatch]);

    // new code

    const [open, setOpen] = React.useState(false);
    const [messageData, setMessageData] = React.useState<any>({});
    const [smsMessage, setSmsMessage] = React.useState('');

    const buildDefaultMessage = (row: any) => {
      const firstName = row?.contactFirstName?.trim();
      const inspectionType = row?.activityTypeName || row?.inspectionType || 'inspection';
      const address = row?.projectAddress;
      const info = row?.information?.trim();
      const greeting = firstName ? `Hi ${firstName},` : 'Hello,';
      const where = address ? ` at ${address}` : '';
      const tail = info ? `\n\nNote: ${info}` : '';
      return `${greeting} this is regarding your ${inspectionType} inspection${where}. Please reach out with any questions.${tail}`;
    };

    const handleClickOpen = row => {
      setMessageData(row);
      setSmsMessage(buildDefaultMessage(row));
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
      setSmsMessage('');
    };
    const [modalSuccess1, setModalSuccess] = React.useState(
      false,
    );

    const [additionalRowData, setAdditionalRowData] = React.useState({});
    const [modalErr, setModalErr] = React.useState(false);
    const handleSendMessage = () => {
      const cellPhone = parseInt(String(messageData?.cellPhone || '').split('-').join(''), 10);
      sendInspectionMessage({
        phone_number: cellPhone,
        inspector_id: messageData?.inspector,
        address: messageData?.projectAddress,
        report_status: messageData?.report ? 'Attached' : 'Not Attached',
        inspection_status: messageData?.information,
        inspection_id: messageData?.id,
        message: smsMessage.trim(),
      })
        .then(() => {
          handleClose();
          setModalSuccess(true);
        })
        .catch(() => {
          handleClose();
          setModalErr(true);
        });
    };

    const onModalClose = () => {
      setModalErr(false);
      setModalSuccess(false);
      updateTable();
    };

    const isReuseFirstRequest = true;

    const {
      isModalOpen,
      modalError,
      modalSuccess,
      modalTitle,
      modalErrorTitle,
      values,
      createOrUpdate,
      handleEdit,
      handleCloseModalInfo,
      handleCloseModal,
      setValues,
      // updateTable,
      setModalTitle,
      openModal,
     } = useTablePage({
       updateEndpoint: updatePermitInspection,
       modalUpdateTitle: 'Update Inspection',
    });
    const inspectorName = useSelector((s:RootState) => s.inspections.inspectorName);
    const [inspectionCount, setInspectionCount] = React.useState(null);
    const [avInspectionCount, setAvInspectionCount] = React.useState(0);
    const additionalActions = row =>
      !row.isDeleted && [
        {
          title: 'Send Message',
          handler: () => {
            if (isReuseFirstRequest) {
              handleClickOpen(row);
            }
          },
          Icon: SmsIcon,
        },
      ];

    // new code
    const getInspections = params =>
      Promise.all([
        getPermitInspections({
          ...params,
          inspector: currentUser,
          // inspectionDate: formatDateTime(
          //   data?.fromDate,
          //   'yyyy-MM-dd',
          //   // '2023-01-06',
          // ),
          dateFrom: formatDateTime(
            data?.fromDate,
            'yyyy-MM-dd',
          ),
          dateTo: formatDateTime(
            data?.fromDate,
            'yyyy-MM-dd',
          ),
          isCompleted: false,
          // ordering: "-is_emergency,follow_up",
          // limit: 25,
          // offset: 0,
          // status: inspectionStatus?.toString(),
          // ordering: ' period, distance',
        }),
        // getProjects({ ...GET_ALL_QUERY_PARAMS }),
        // getPermits({ ...GET_ALL_QUERY_PARAMS }),
        // getInspectionTypes({ ...GET_ALL_QUERY_PARAMS }),
        // getUsers({
        //   ...GET_ALL_QUERY_PARAMS,
        //   userRole: USER_TYPES_VALUES.INSPECTOR,
        // }),
        // getUsers({
        //   ...GET_ALL_QUERY_PARAMS,
        //   userRole: USER_TYPES_VALUES.EMPLOYEE,
        // }),
        // getUsers({
        //   ...GET_ALL_QUERY_PARAMS,
        // }),
        // getVocabulariesDataList({
        //   ...GET_ALL_QUERY_PARAMS,
        //   vocabularyEntity: 3,
        //   ordering: 'title',
        // }),
      ]).then(
        ([
          inspectionsResponse,
          // projectsResponse,
          // permitsResponse,
          // inspectionTypesResponse,
          // inspectorsResponse,
          // employeesResponse,
          // allUsersResponse,
          // typesResponse,
        ]) => {
          if (inspectionsResponse.data?.results?.length === 0) {
            setIsValidForExport(false);
            dispatch(setInspectorName(null));
          } else {
            // Inspector name is already set from getCurrentUser, just keep it
            setInspectionCount(inspectionsResponse?.data?.count);
            setIsValidForExport(true);
            dispatch(setInspectionsTypeData(inspectionsResponse.data.results));
            const commentData = inspectionsResponse.data.results.map(
              el => ({
                id: el.id,
                lastComment: el.lastComment,
              }),
            );
            setLastComment({
              commentData,
              isDailyInspection: true,
            });
            const informationData = inspectionsResponse.data.results.map(
              el => ({
                id: el.id,
                information: el.information,
              }),
            );

            const recordData = inspectionsResponse.data.results.map(
              el => ({
                id: el.id,
                name: `${el?.projectName} | ${el?.permitName}`,
                address: el?.projectAddress,
              }),
            );

            setAdditionalRowData({
              commentData,
              informationData,
              recordData,
              isDailyInspection: true,
            });
          }
          return {
            ...inspectionsResponse,
            data: {
              ...inspectionsResponse.data,
              results: inspectionsResponse.data.results.map(
                item => {
                  const _item = { ...item };
                  delete (_item.projectAddress);
                  // delete(_item['inspectionDate']);
                  return {
                    ..._item,
                    // projectNamePermitName: `${item?.projectName} | ${item?.permitName}`,
                    permitNumber: _item?.permitNumber,
                    // projectAddress: item?.projectAddress,
                    projectManager: `${_item?.managerFirstName} ${_item?.managerLastName}`,
                    jurisdiction: _item?.projectJurisdiction,
                    inspectionType: _item?.activityTypeName,
                    id: _item?.id,
                    // inspectionDate: item.inspectionDate
                    //   ? item.inspectionDate
                    //   : '',
                    period: calculatePeriod(_item),

                    contact: `${_item?.contactFirstName} ${_item?.contactLastName}`,
                      //  contact?.firstName && item?.contact
                      //  ? `${contact?.firstName} ${contact?.lastName}`
                      //  : '',
                    contactPhone: _item?.phoneNumber,
                    //  contact?.firstName && item?.contact
                    //   ? `${contact.phoneNumber}`
                    //   : '',
                      cellPhone: _item?.cellPhone,
                    //  contact?.firstName && item?.contact
                    //   ? `${contact.mobilePhoneNumber}`
                    //   : '',

                  };
                },
              ),
            },
          };
        },
      );

      const handleInspectionEdit = params => {
        const param = { id: params?.id };
        Promise.all([getPermitInspectionById(param)]).then(([inspection]) => {
          setValues(inspection?.data);
          setModalTitle(inspection?.data?.isDeleted ? '' : 'Update');
          openModal(true);
        });
      };
      const closeInfoModal = () => {
        // getInspections({})
        updateTable();
        handleCloseModalInfo();
      };

    return (
      <Wrapper ref={ref}>
        <Container>
          {(modalSuccess1 || modalErr) && (
            <ModalInfo
              timeToClose={5000}
              isError={modalErr}
              onClose={() => onModalClose()}
              errorMsg="Cannot send the message"
            />
          )}
          {open && (
            <ModalDefaultDraggable
              title="Send SMS"
              onClose={handleClose}
              narrow
            >
              <SmsForm>
                <SmsField>
                  <SmsLabel>Receiver</SmsLabel>
                  <ReceiverCard>
                    <ReceiverName>
                      {[messageData?.contactFirstName, messageData?.contactLastName]
                        .filter(Boolean)
                        .join(' ') || messageData?.contact || '—'}
                    </ReceiverName>
                    <ReceiverPhone>{messageData?.cellPhone || 'No phone number on file'}</ReceiverPhone>
                  </ReceiverCard>
                </SmsField>

                <SmsField>
                  <SmsLabelRow>
                    <SmsLabel htmlFor="sms-message">Message</SmsLabel>
                    <SmsCounter>{smsMessage.length}/1600</SmsCounter>
                  </SmsLabelRow>
                  <SmsTextarea
                    id="sms-message"
                    value={smsMessage}
                    onChange={e => setSmsMessage(e.target.value.slice(0, 1600))}
                    placeholder="Type the message to send…"
                    rows={6}
                  />
                  <SmsHint>
                    A default message has been filled in. Edit it as needed before sending.
                  </SmsHint>
                </SmsField>

                <SmsActions>
                  <SmsCancel type="button" onClick={handleClose}>
                    Cancel
                  </SmsCancel>
                  <SmsSend
                    type="button"
                    onClick={handleSendMessage}
                    disabled={!smsMessage.trim() || !messageData?.cellPhone}
                  >
                    Send SMS
                  </SmsSend>
                </SmsActions>
              </SmsForm>
            </ModalDefaultDraggable>
          )}
        </Container>
        {currentUser && <LegacyMobileBlock><DailyInspections data={additionalRowData} tableData={tableData} onClick={handleClickOpen} /></LegacyMobileBlock>}
        {currentUser && <TableWrapper>
          <Card>
            <CardHeader>
              <PrintBrandRow>
                <PrintLogo src={logo} alt="Elite Permits" />
                <PrintBrandName>Elite Permits</PrintBrandName>
              </PrintBrandRow>
              <TitleRow>
                <TitleIcon $bg="#E9F2FF" $fg="#2563EB">
                  <AssignmentIcon />
                </TitleIcon>
                <TitleText>
                  <Eyebrow>Report</Eyebrow>
                  <Title>Daily Inspection Report</Title>
                </TitleText>
                {toolbar && <ToolbarSlot>{toolbar}</ToolbarSlot>}
              </TitleRow>
            </CardHeader>
            <CardBody>
              {(inspectorName && (inspectionCount > 0 || avInspectionCount > 0)) && (
                <StatsGrid>
                  <StatTile>
                    <StatIcon $bg="#F3E8FF" $fg="#9333EA">
                      <PersonIcon />
                    </StatIcon>
                    <StatBody>
                      <StatLabel>Inspector</StatLabel>
                      <StatValue title={inspectorName}>{inspectorName}</StatValue>
                    </StatBody>
                  </StatTile>
                  <StatTile>
                    <StatIcon $bg="#E9F2FF" $fg="#2563EB">
                      <EventIcon />
                    </StatIcon>
                    <StatBody>
                      <StatLabel>Inspection Date</StatLabel>
                      <StatValue>{formatDateTime(fromDate, 'MM/dd/yyy')}</StatValue>
                    </StatBody>
                  </StatTile>
                  <StatTile>
                    <StatIcon $bg="#FFF1D6" $fg="#B7800A">
                      <AccessTimeIcon />
                    </StatIcon>
                    <StatBody>
                      <StatLabel>Report Date</StatLabel>
                      <StatValue>{formatDateTime(new Date(), DATETIME_FORMAT)}</StatValue>
                    </StatBody>
                  </StatTile>
                  <StatTile>
                    <StatIcon $bg="#DCFCE7" $fg="#16A34A">
                      <InsertChartIcon />
                    </StatIcon>
                    <StatBody>
                      <StatLabel>Total Inspections</StatLabel>
                      <StatValue>{inspectionCount ?? '—'}</StatValue>
                    </StatBody>
                  </StatTile>
                  <StatTile>
                    <StatIcon $bg="#CFFAF4" $fg="#0E9488">
                      <VideocamIcon />
                    </StatIcon>
                    <StatBody>
                      <StatLabel>Total A/V Inspections</StatLabel>
                      <StatValue>{avInspectionCount ?? 0}</StatValue>
                    </StatBody>
                  </StatTile>
                </StatsGrid>
              )}
              <DailyInspectionsSearchBox />
              <DailyInspectionRecords
                setTableData={setTableData}
                fromDate={fromDate}
                setInspectorName={setInspectorName}
                setInspectionCount={setInspectionCount}
                setAvInspectionCount={setAvInspectionCount}
                handleEdit={handleEdit}
                openSMS={handleClickOpen}
                setIsValidForExport={setIsValidForExport}
              />
            </CardBody>
          </Card>
        </TableWrapper>}

        {isModalOpen && (
        <ModalDefaultDraggable
          title={modalTitle}
          onClose={handleCloseModal}
        >
          <PermitInspectionsForm
            onSubmit={createOrUpdate}
            initialValues={values}
            modalError={modalError}
            addButtonText="Create"
            updateButtonText="Update"
            initialErrors={errors}
            permit={values?.permit}
            // isReadOnly={true}
            setInitialValues={setValues}
            updateTable={updateTable}
          />
        </ModalDefaultDraggable>
      )}
        {(modalSuccess || modalError) && (
        <ModalInfo
          timeToClose={5000}
          isError={modalError}
          onClose={closeInfoModal}
          errorMsg={modalErrorTitle}
        />
      )}

      </Wrapper>
    );
  },
);

const FONT_STACK = `'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif`;

const Card = styled.div`
  width: 100%;
  box-sizing: border-box;
  background: var(--neutral-0);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: var(--shadow-xs);
  font-family: ${FONT_STACK};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;

  &:hover {
    border-color: var(--neutral-300);
    box-shadow: var(--shadow-sm, 0 2px 6px rgba(15, 23, 42, 0.08));
  }

  @media print {
    border: none;
    box-shadow: none;
    border-radius: 0;
    overflow: visible;
    color: #000;
    font-family: 'Segoe UI', Arial, sans-serif;
  }
`;

const CardHeader = styled.div`
  padding: 14px 18px;
  background: var(--neutral-0);
  border-bottom: 1px solid var(--border);

  @media print {
    border-bottom: 2px solid #000;
    padding: 0 0 10px;
    margin-bottom: 12px;
  }
`;

const PrintBrandRow = styled.div`
  display: none;

  @media print {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 8px;
  }
`;

const PrintLogo = styled.img`
  height: 28px;
  width: auto;
`;

const PrintBrandName = styled.span`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #000;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex-wrap: wrap;
`;

const ToolbarSlot = styled.div`
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  @media print {
    display: none;
  }

  @media only screen and (max-width: 840px) {
    width: 100%;
    margin-left: 0;
  }
`;

const TitleIcon = styled.div<{ $bg: string; $fg: string }>`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: ${({ $bg }) => $bg};
  color: ${({ $fg }) => $fg};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    font-size: 20px;
  }

  @media print {
    display: none;
  }
`;

const TitleText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

const Eyebrow = styled.span`
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--neutral-500);
  line-height: 1.2;

  @media print {
    display: none;
  }
`;

const Title = styled.h1`
  margin: 0;
  font-size: 1.0625rem;
  font-weight: 700;
  color: var(--mainText);
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media print {
    font-size: 22px;
    font-weight: 800;
    white-space: normal;
    color: #000;
  }
`;

const CardBody = styled.div`
  padding: 18px;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;

  @media print {
    padding: 0;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  margin-bottom: 16px;

  @media print {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px 28px;
    margin: 0 0 14px;
    padding: 8px 0 12px;
    border-bottom: 1px solid #000;
  }
`;

const StatTile = styled.div`
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: var(--neutral-50);
  border: 1px solid var(--border);
  border-radius: 10px;
  min-width: 0;

  @media print {
    display: grid;
    grid-template-columns: max-content minmax(0, 1fr);
    align-items: baseline;
    gap: 0 8px;
    padding: 0;
    background: none;
    border: none;
    border-radius: 0;
    margin: 0;
    line-height: 1.5;
  }
`;

const StatIcon = styled.div<{ $bg: string; $fg: string }>`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: ${({ $bg }) => $bg};
  color: ${({ $fg }) => $fg};
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 20px;
  }

  @media print {
    display: none;
  }
`;

const StatBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;

  @media print {
    display: inline;
  }
`;

const StatLabel = styled.span`
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--neutral-500);
  line-height: 1.2;

  @media print {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    color: #555;

    &::after {
      content: ':';
    }
  }
`;

const StatValue = styled.span`
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--mainText);
  line-height: 1.3;
  font-variant-numeric: tabular-nums;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media print {
    font-size: 11px;
    font-weight: 600;
    color: #000;
    overflow: visible;
    white-space: normal;
  }
`;

const TableWrapper = styled.div`
  width: 100%;
`;

const LegacyMobileBlock = styled.div`
  display: none;
`;

const Container = styled.fieldset`
  display: block;
  margin: 0;
  padding: 0;
  width: 100%;
  border: none;
  text-align: center;
`;

const SMS_FONT_STACK = `'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif`;

const SmsForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  font-family: ${SMS_FONT_STACK};
  text-align: left;
  box-sizing: border-box;
`;

const SmsField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const SmsLabelRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
`;

const SmsLabel = styled.label`
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--neutral-500);
`;

const SmsCounter = styled.span`
  font-size: 0.75rem;
  color: var(--neutral-500);
`;

const ReceiverCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--neutral-50);
`;

const ReceiverName = styled.span`
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--mainText);
  line-height: 1.3;
`;

const ReceiverPhone = styled.span`
  font-size: 0.8125rem;
  color: var(--neutral-600);
  font-variant-numeric: tabular-nums;
`;

const SmsTextarea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 10px 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--neutral-0);
  font-family: inherit;
  font-size: 0.875rem;
  line-height: 1.5;
  color: var(--mainText);
  resize: vertical;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &::placeholder {
    color: var(--neutral-400);
  }

  &:hover {
    border-color: var(--neutral-400);
  }

  &:focus {
    outline: none;
    border-color: var(--primary-600);
    box-shadow: var(--shadow-focus);
  }
`;

const SmsHint = styled.span`
  font-size: 0.75rem;
  color: var(--neutral-500);
  line-height: 1.4;
`;

const SmsActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 4px;
`;

const SmsCancel = styled.button`
  height: 38px;
  padding: 0 16px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--neutral-0);
  color: var(--neutral-700);
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: var(--neutral-50);
    border-color: var(--neutral-400);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }
`;

const SmsSend = styled.button`
  height: 38px;
  padding: 0 18px;
  border: none;
  border-radius: 8px;
  background: var(--primary-600);
  color: var(--neutral-0);
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover:not(:disabled) {
    background: var(--primary-700);
  }

  &:focus-visible {
    outline: none;
    box-shadow: var(--shadow-focus);
  }

  &:disabled {
    background: var(--neutral-200);
    color: var(--neutral-500);
    cursor: not-allowed;
  }
`;

export default DailyInspectorReport;
